/* eslint-disable no-script-url */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { cn } from '../../../Utils/component'
import FacebookIcon from '../../ui/icons/socials/facebookIcon'
import InstagramIcon from '../../ui/icons/socials/instagramIcon'
import LinkedinIcon from '../../ui/icons/socials/linkedinIcon'
import { TiktokIcon } from '../../ui/icons/socials/tiktokIcon'
import TwitterIcon from '../../ui/icons/socials/twitterIcon'
import YoutubeIcon from '../../ui/icons/socials/youtubeIcon'

export const Copyright = ({
  careerSite = false,
  careerSiteColor = undefined,
}: {
  careerSite?: boolean
  careerSiteColor?: string
}) => {
  const links = [
    {
      label: 'Politique de confidentialité',
      title: 'Notre Politique de confidentialité',
      link: '/politique-confidentialite',
      isExternal: true,
      rel: 'terms-of-service noreferrer',
    },
    {
      label: 'Conditions générales',
      title: 'Nos Conditions Générales d’Utilisation',
      link: '/conditions-generales-dutilisation',
      isExternal: true,
      rel: 'terms-of-service noreferrer',
    },
  ]

  const socials = [
    {
      link: 'https://www.facebook.com/lamacompta.co',
      icon: <FacebookIcon />,
      title: 'Lamacompta sur Facebook',
    },
    {
      link: 'https://www.instagram.com/lamacompta/',
      icon: <InstagramIcon />,
      title: 'Lamacompta sur Instagram',
    },
    {
      link: 'https://twitter.com/lamacompta',
      icon: <TwitterIcon />,
      title: 'Lamacompta sur Twitter',
    },
    {
      link: 'https://www.linkedin.com/company/lamacompta',
      icon: <LinkedinIcon />,
      title: 'Lamacompta sur LinkedIn',
    },
    {
      link: 'https://www.youtube.com/@lamacompta',
      icon: <YoutubeIcon />,
      title: 'Lamacompta sur YouTube',
    },
    {
      link: 'https://www.tiktok.com/@lamacompta',
      icon: <TiktokIcon />,
      title: 'Lamacompta sur TikTok',
    },
  ]
  return (
    <div className="py-6 pb-10 border-t md:flex md:items-center md:justify-between lg:pb-12 lg:py-8 border-t-night">
      <ul
        role="menu"
        className="space-y-2 md:space-y-0 md:items-center md:space-x-4 md:flex"
      >
        <p className="text-sm font-thin text-night">
          {`© ${new Date().getFullYear()} Lamacompta. Tous droits réservés.`}
        </p>
        {links.map(({ title, link, isExternal, label, rel }) => (
          <li role="menuitem" key={title}>
            <a
              key={title}
              title={title}
              href={link}
              target={isExternal ? '_blank' : '_self'}
              rel={rel}
              aria-label={title}
              className={cn(
                'text-sm font-thin underline transition-colors duration-300 ease-in-out text-night',
                careerSite
                  ? `hover:text-[${careerSiteColor?.toLowerCase()}]`
                  : 'hover:text-primary',
              )}
            >
              {label}
            </a>
          </li>
        ))}
        <li role="menuitem">
          <a
            href="javascript:openAxeptioCookies()"
            className={cn(
              'text-sm font-thin underline transition-colors duration-300 ease-in-out text-night',
              careerSite
                ? `hover:text-[${careerSiteColor?.toLowerCase()}]`
                : 'hover:text-primary',
            )}
          >
            Voir les cookies
          </a>
        </li>
      </ul>

      <ul role='menu' className="flex justify-center items-center mt-6 space-x-2 md:mt-0 md:justify-normal">
        {socials.map(({ link, icon, title }) => (
          <li
            key={link}
            role="menuitem"
            className={cn('rounded-full p-[2px]', !careerSite && 'bg-primary')}
            style={{
              backgroundColor: careerSite ? `${careerSiteColor}` : undefined,
            }}
            aria-label={title}
          >
            <a
              href={link}
              target="_blank"
              className="w-[30px] h-[30px] xl:w-[20px] xl:h-[20px] rounded-full flex items-center mx-auto text-white"
              rel="noopener noreferrer"
              aria-label={title}
            >
              {icon}
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}
